import { render, staticRenderFns } from "./TheStub.vue?vue&type=template&id=403f7670&scoped=true&"
import script from "./TheStub.vue?vue&type=script&lang=js&"
export * from "./TheStub.vue?vue&type=script&lang=js&"
import style0 from "./TheStub.vue?vue&type=style&index=0&id=403f7670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403f7670",
  null
  
)

export default component.exports